import {Injectable} from '@angular/core';
import {FnaApiService} from '@emma-labs/shared/angular';
import {Fna} from '@emma-labs/shared/typescript';
import {first, mergeMap, Observable} from 'rxjs';
import {AuthService} from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class FnaService {
  constructor(
    private readonly authService: AuthService,
    private readonly fnaApiService: FnaApiService,
  ) {}

  create(fna: Fna): Observable<Fna> {
    return this.authService.currentAgentSessionOrAuthError.pipe(
      first(),
      mergeMap((session) => this.fnaApiService.create(session.id, fna)),
    );
  }

  get(id: string): Observable<Fna> {
    return this.authService.currentAgentSessionOrAuthError.pipe(
      first(),
      mergeMap((session) => this.fnaApiService.getById(session.id, id)),
    );
  }

  update(id: string, fna: Fna): Observable<Fna> {
    return this.authService.currentAgentSessionOrAuthError.pipe(
      first(),
      mergeMap((session) => this.fnaApiService.update(session.id, id, fna)),
    );
  }
}
